import React, { Component } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import bootstrapPlugin from '@fullcalendar/bootstrap';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import { getSeniorsShiftsByWardId } from '../../UserFunctions';

import { Modal, Button} from 'react-bootstrap';

import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';


export class OrthopedicShifts extends Component {

  state = { shifts: [], modalShow: null, setModalShow: null, info: null };


    eventClickFunc = (info) => {
      

      this.setState({info: info, EventModalShow: true});
      console.log(this.state.info.event);
      info.jsEvent.preventDefault();
    }

    eventClickFunc2 = (info) => {
      

      this.setState({EventModalShow: true});
      console.log(info.event.title);
      info.jsEvent.preventDefault();
    }

    handleDateClick = (start, end, allDay) => { // Need to change Modal to eventClickFunc

      
      }

      componentDidMount() {
        const ward = {
          ward_id: '1'
        }
        getSeniorsShiftsByWardId(ward).then(res => {
          var shifts_fetched = res.map(shift => {
            return {
              title: shift.surgeon_senior.first_name + ' ' + shift.surgeon_senior.last_name,
              start: shift.st_time,
              end: shift.end_time,
              extendedProps: {
                senior_id: shift.senior_id,
                first_name: shift.surgeon_senior.first_name,
                last_name: shift.surgeon_senior.last_name,
                email: shift.surgeon_senior.email,
                ward_id: shift.surgeon_senior.ward_id,
                address: shift.surgeon_senior.address,
                phone_number: shift.surgeon_senior.phone_number,
              }
            }
          })
          this.setState({ shifts: shifts_fetched, EventModalShow: false })
          console.log(shifts_fetched)
          console.log(res);
        }).catch(err => {
          console.log(err);
        })
    
        
      }

    render() {
      
      function MyVerticallyCenteredModal(props) {
        console.log(props);
        return (
          <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
              <h3 style={{ color: 'darkblue', fontWeight: 'bold' }}>Shift Information</h3>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h5>{!props.currinfo ? "ERROR" : "Senior ID: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.senior_id}
              <h5>{!props.currinfo ? "ERROR" : "First Name: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.first_name}
              <h5>{!props.currinfo ? "ERROR" : "Last Name: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.last_name}
              <h5>{!props.currinfo ? "ERROR" : "Email: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.email}
              <h5>{!props.currinfo ? "ERRPR" : "Address: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.address}
              <h5>{!props.currinfo ? "ERRPR" : "Phone Number: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.extendedProps.phone_number}
              <h5>{!props.currinfo ? "ERROR" : "Starting Time: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.start.toString()}
              <h5>{!props.currinfo ? "ERROR" : "Ending Time: "}</h5> {!props.currinfo ? "Error" : props.currinfo.event.end.toString()}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
          </Modal>
        );
      }

      let EventModalClose = () => this.setState({EventModalShow: false, info: null});

      const handle_nullify = () => alert('Need to nullify the calendar!!!');
        return (
          
          <div>
            
            <FullCalendar 
            editable='false'
            selectable='true' 
            dateClick={this.handleDateClick} 
            defaultView="timeGridWeek" 
            plugins={[ dayGridPlugin, bootstrapPlugin, interactionPlugin, listPlugin, timeGridPlugin ]} 
            events={this.state.shifts}
            nowIndicator='true'
            eventClick={this.eventClickFunc}
            header={{
              left: 'prev,next today,     add_event',
              center: 'title',
              right: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
            }}

            themeSystem = 'bootstrap'
            />

            <Button variant="danger" onClick={handle_nullify}>Nullify the Calendar</Button>
            <MyVerticallyCenteredModal
              show={this.state.EventModalShow}
                onHide={EventModalClose}
                currinfo ={this.state.info}
            />
            </div>

        )
    }
}

export default OrthopedicShifts